"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParamFactory = void 0;
var flApi = require("./flApi");
var paramObj = require("./param");
var ParamFactory = (function () {
    function ParamFactory() {
        var _this = this;
        this.allParam = new Array();
        this.paramEcns = [];
        this.notifParamFactory = function (msg) {
            try {
                if (msg.type === "data" && msg.eCN === 180) {
                    msg.data.forEach(function (aDataNotif) {
                        switch (msg.operation) {
                            case "i":
                                var paramDefObj = _this.loadFromJson(aDataNotif);
                                paramDefObj.instance = new paramObj.Param(paramDefObj, []);
                                _this.allParam.push(paramDefObj);
                                _this.paramEcns.push(paramDefObj.eCN);
                                break;
                            case "u":
                                var myIdxUpd = _this.allParam.findIndex(function (p) { return aDataNotif.c181 === p.name; });
                                if (myIdxUpd > -1) {
                                    _this.allParam[myIdxUpd] = _this.updateMeFromJson(aDataNotif, myIdxUpd);
                                }
                                ;
                                break;
                            case "d":
                                var myIdx = _this.allParam.findIndex(function (p) { return aDataNotif.c181 === p.name; });
                                if (myIdx > -1) {
                                    var tmpEcn_1 = _this.allParam[myIdx].eCN;
                                    if (_this.allParam[myIdx].instance !== undefined) {
                                        _this.allParam[myIdx].instance = undefined;
                                    }
                                    _this.allParam.splice(myIdx, 1);
                                    myIdx = _this.paramEcns.findIndex(function (e) { return e === tmpEcn_1; });
                                    if (myIdx > -1) {
                                        _this.paramEcns.splice(myIdx, 1);
                                    }
                                }
                                break;
                        }
                    });
                }
            }
            catch (err) {
                console.error(err.stack || err);
            }
            return [];
        };
        this.notifParamObject = function (msg) {
            try {
                if (msg.type !== "data" || msg.eCN === -1) {
                    return [];
                }
                if (_this.paramEcns.indexOf(msg.eCN) > -1) {
                    var myParamDef_1 = _this.allParam.find(function (p) { return msg.eCN === p.eCN; });
                    if (myParamDef_1 !== undefined && myParamDef_1.instance !== undefined) {
                        try {
                            var oldData_1 = new Array();
                            if (myParamDef_1.instance.isLoaded() && msg.operation === "d") {
                                msg.data.forEach(function (aMsgData) {
                                    oldData_1.push({
                                        id: aMsgData.id,
                                        param: myParamDef_1.instance.get(aMsgData.id),
                                    });
                                });
                            }
                            myParamDef_1.instance.notifyMe(msg);
                            if (myParamDef_1.instance.isLoaded() && msg.operation !== "d") {
                                msg.data.forEach(function (aMsgData) {
                                    oldData_1.push({
                                        id: aMsgData.id,
                                        param: myParamDef_1.instance.get(aMsgData.id),
                                    });
                                });
                            }
                            var paramNotif = {
                                type: "paramUpdate",
                                dbName: msg.dbName,
                                paramObj: myParamDef_1.instance,
                                data: oldData_1,
                                operation: msg.operation,
                            };
                            return [paramNotif];
                        }
                        catch (err) {
                            console.error("Error in notif Param processing: " + err.stack);
                        }
                    }
                }
            }
            catch (err) {
                console.error(err.stack || err);
            }
            return [];
        };
    }
    ParamFactory.prototype.resetAndLoad = function (m180) {
        var _this = this;
        try {
            if (this.fl === undefined) {
                this.fl = flApi.Api.getInstance();
                this.fl.restApi.addNotificationHandler("paramFactory", this.notifParamFactory, 1);
                this.fl.restApi.addNotificationHandler("paramValues", this.notifParamObject, 2);
            }
            this.allParam = new Array();
            this.paramEcns = [];
            m180.forEach(function (aParamDef) {
                var tmpParamObject = _this.loadFromJson(aParamDef);
                _this.allParam.push(tmpParamObject);
                _this.paramEcns.push(aParamDef.c183);
            });
        }
        catch (err) {
            console.error(err.stack);
            throw err;
        }
    };
    ParamFactory.prototype.getParamsName = function () {
        var pNames = [];
        this.allParam.forEach(function (aParam) {
            pNames.push(aParam.name);
        });
        return pNames;
    };
    ParamFactory.prototype.get = function (name) {
        try {
            var tmpParam = this.allParam.find(function (p) { return p.name === name; });
            if (tmpParam === undefined) {
                throw new Error("Unknown parameter name");
            }
            return tmpParam.instance;
        }
        catch (err) {
            throw err;
        }
    };
    ParamFactory.prototype.getAndLoad = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var tmpParam, tmpParamObject, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        tmpParam = this.allParam.find(function (p) { return p.name === name; });
                        if (tmpParam === undefined) {
                            throw new Error("Unknown parameter name");
                        }
                        tmpParamObject = tmpParam.instance;
                        if (!!tmpParamObject.isLoaded()) return [3, 2];
                        return [4, tmpParamObject.loadValues()];
                    case 1:
                        _a.sent();
                        tmpParam = this.allParam.find(function (p) { return p.name === name; });
                        if (tmpParam.instance === undefined) {
                            throw new Error("parameter " + name + " error during loading");
                        }
                        _a.label = 2;
                    case 2: return [2, tmpParam.instance];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4: return [2];
                }
            });
        });
    };
    ParamFactory.prototype.getOption = function (name) {
        try {
            var myParam = this.allParam.find(function (p) { return p.name === name; });
            if (myParam === undefined) {
                throw new Error("Unknown parameter name");
            }
            if (myParam.option === -1) {
                throw new Error("Parameter not loaded");
            }
            return myParam.option;
        }
        catch (err) {
            throw err;
        }
    };
    ParamFactory.prototype.changeOption = function (name, newOption) {
        return __awaiter(this, void 0, void 0, function () {
            var myParam, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        myParam = this.allParam.find(function (p) { return p.name === name; });
                        if (myParam === undefined) {
                            throw new Error("Unknown parameter name");
                        }
                        return [4, this.fl.restApi.updateParamOption(name, newOption)];
                    case 1:
                        _a.sent();
                        return [2, myParam];
                    case 2:
                        err_2 = _a.sent();
                        throw err_2;
                    case 3: return [2];
                }
            });
        });
    };
    ParamFactory.prototype.createNewParameter = function (name, option, filter) {
        if (filter === void 0) { filter = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var myParam, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        myParam = this.allParam.find(function (p) { return p.name === name; });
                        if (myParam !== undefined) {
                            throw new Error("Parameter allready exist");
                        }
                        return [4, this.fl.restApi.createParam(name, option, filter)];
                    case 1:
                        _a.sent();
                        myParam = this.allParam.find(function (p) { return p.name === name; });
                        if (myParam === undefined) {
                            throw new Error("Parameter not created in notification handler...");
                        }
                        return [2, myParam.instance];
                    case 2:
                        err_3 = _a.sent();
                        throw err_3;
                    case 3: return [2];
                }
            });
        });
    };
    ParamFactory.prototype.deleteParameter = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var myParam, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        myParam = this.allParam.find(function (p) { return p.name === name; });
                        if (myParam === undefined) {
                            throw new Error("Unknown parameter name");
                        }
                        return [4, this.fl.restApi.deleteParam(name)];
                    case 1:
                        _a.sent();
                        return [2];
                    case 2:
                        err_4 = _a.sent();
                        throw err_4;
                    case 3: return [2];
                }
            });
        });
    };
    ParamFactory.prototype.createClientParameters = function (allParam) {
        var _this = this;
        if (allParam === void 0) { allParam = new Array(); }
        allParam.forEach(function (aParamUseResp) {
            try {
                var paramDefObj = _this.loadFromJson(aParamUseResp.def);
                paramDefObj.instance = new paramObj.Param(paramDefObj, aParamUseResp.values === undefined ? ["emptyParamfl_12345"] : aParamUseResp.values);
                _this.allParam.push(paramDefObj);
                _this.paramEcns.push(paramDefObj.eCN);
            }
            catch (err) {
                throw err;
            }
        });
    };
    ParamFactory.prototype.loadFromJson = function (jParamDef) {
        var myDef = {
            name: jParamDef.c181,
            option: jParamDef.c182,
            eCN: jParamDef.c183,
            fCN: jParamDef.c184,
            fCNOnDemand: jParamDef.c185,
            filter: jParamDef.c186,
            instance: undefined,
            json: jParamDef,
        };
        myDef.instance = new paramObj.Param(myDef, ["emptyParamfl_12345"]);
        return myDef;
    };
    ParamFactory.prototype.updateMeFromJson = function (jParamDef, idx) {
        if (idx === -1 || idx > this.allParam.length) {
            throw new Error("invalid index " + idx);
        }
        var myDef = this.allParam[idx];
        myDef.name = jParamDef.c181;
        myDef.option = jParamDef.c182;
        myDef.eCN = jParamDef.c183;
        myDef.fCN = jParamDef.c184;
        myDef.fCNOnDemand = jParamDef.c185;
        myDef.filter = jParamDef.c186;
        myDef.json = jParamDef;
        return myDef;
    };
    return ParamFactory;
}());
exports.ParamFactory = ParamFactory;
